import updatedPromosList from './update-promo-list';
import setPromocodePopupContent from './promocode-popup';
import updateCart from './update-popup-cart.js';
import { applyPromoFromBanner } from './helpers';
import { fetchData, postData, deleteData } from './fetch';

import './update-product-quantity';
import './promo-logic';

window.addEventListener('load', () => {
  const promoProductsForm = document.querySelectorAll('.promo-products-form');
  const promoSwiper = document.querySelector('.promo-swiper');
  const headerContentWrapper = document.querySelector(
    '.header-content-wrapper',
  );
  const promocodeForm = document.querySelector('.promocode-form');
  const promocodeInput = document.querySelector(
    '.promocode-input-wrapper input',
  );
  const promocodeSubmit = document.querySelector('.promocode-submit');
  const promocodeInputWrapper = document.querySelector('.promocode-input');
  const promocodeError = document.querySelector('.promocode-error');
  const addPromoProductBtn = document.querySelectorAll('.add-promo-product');
  const applyPromoBtn = document.querySelectorAll('.apply-promo');
  const promoList = document.querySelector('.promo-list');
  const popupCancelPromoBtn = document.querySelector(
    '.promocode-popup .remove-promo',
  );
  const promocodePopup = document.querySelector('.promocode-popup-wrapper');
  const promocodePopupInput = document.querySelector(
    '.promocode-popup .promocode-input input',
  );
  const promocodeDescription = document.querySelector(
    '.promocode-popup .promo-description',
  );
  const promoError = document.querySelector('.promocode-popup .promo-error');
  const promocodePopupInputWrapper = document.querySelector(
    '.promocode-popup .promocode-input',
  );
  const promocodePopupPromotionProducts = document.querySelector(
    '.promocode-popup .promotion-products',
  );
  const promocodePopupBackButton = document.querySelector(
    '.promocode-popup .back-button',
  );
  const applyPromoWithVariants = document.querySelector(
    '.apply-promo-with-variants',
  );
  const promotionProductsList = document.querySelector(
    '.promotion-products-list',
  );
  const promoSetButton = document.querySelectorAll('.add-set-product');
  const lazyImages = [].slice.call(document.querySelectorAll('.product-card-image'));

  if ("IntersectionObserver" in window) {
    const lazyImageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const lazyImage = entry.target;

          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove('loading');
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    lazyImages.forEach(function (lazyImage) {
      lazyImage.src = lazyImage.dataset.src;
      lazyImage.classList.remove('loading');
    });
  }

  if (promoSwiper) {
    let headerWidth = headerContentWrapper.offsetWidth - 40;

    let autoplayTimeout;

    const promoSlider = new Swiper('.promo-swiper', {
      lazy: true,
      slidesPerView: 1.2,
      spaceBetween: 0,
      effect: 'coverflow',
      loop: true,
      centeredSlides: true,
      speed: 400,
      breakpoints: {
        768: {
          allowTouchMove: true,
        },
        1025: {
          allowTouchMove: false,
        },
      },
      coverflowEffect: {
        rotate: 0,
        slideShadows: true,
        depth: 500,
      },
      autoplay: {
        delay: 6000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    if (window.innerWidth <= 895) {
      headerWidth = headerContentWrapper.offsetWidth - 26;
    }

    promoSlider.on('autoplayStop', () => {
      clearTimeout(autoplayTimeout);

      autoplayTimeout = setTimeout(() => {
        promoSlider.autoplay.start();
      }, 3000);
    });

    const slides = promoSwiper.querySelectorAll('.swiper-slide .slide-wrapper');
    const popupButtons = promoSwiper.querySelectorAll(
      '.swiper-slide .slider-popup-btn',
    );

    if (popupButtons) {
      [].forEach.call(popupButtons, (btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const { id } = btn.dataset;

          if (document.getElementById(id)) {
            document.getElementById(id).classList.add('active');
          }
        });
      });
    }

    const activeSlide = promoSwiper.querySelector('.swiper-slide-active');

    setTimeout(() => {
      if (activeSlide) {
        const image = activeSlide.querySelector('.banner-mobile');

        if (window.innerWidth <= 990) {
          [].forEach.call(slides, (slide) => {
            const parentElement = slide.closest('.swiper-slide');

            if (parentElement && !parentElement.classList.contains('swiper-slide-active')) {
              const banner = slide.querySelector('.banner-mobile');
              banner.style.maxHeight = `${image.height}px`;
            }
          });
        }
      }
    }, 100);

    [].forEach.call(slides, (slide) => {
      slide.style.width = `${headerWidth}px`;
    });

    promoSlider.on('resize', () => {
      const swiperSlides = promoSwiper.querySelectorAll('.swiper-slide');
      headerWidth = headerContentWrapper.offsetWidth - 40;

      if (window.innerWidth <= 990) {
        headerWidth = headerContentWrapper.offsetWidth - 26;

        const activeSlide = promoSwiper.querySelector('.swiper-slide-active');

        if (activeSlide) {
          const image = activeSlide.querySelector('.banner-mobile');
          image.style.maxHeight = '100%';
        }

        setTimeout(() => {
          if (activeSlide) {
            const image = activeSlide.querySelector('.banner-mobile');

            [].forEach.call(slides, (slide) => {
              const parentElement = slide.closest('.swiper-slide');

              if (parentElement && !parentElement.classList.contains('swiper-slide-active')) {
                const banner = slide.querySelector('.banner-mobile');
                banner.style.maxHeight = `${image.height}px`;
              }
            });
          }
        }, 100);
      }

      [].forEach.call(swiperSlides, (slide) => {
        const swiperSlide = slide.querySelector('.slide-wrapper');

        if (swiperSlide) {
          swiperSlide.style.width = `${headerWidth}px`;
        }
      });
    });
  }

  if (promoProductsForm) {
    [].forEach.call(promoProductsForm, (form) => {
      const formCheckboxes = form.elements['promo-product[]'];
      const { conditions } = form.dataset;
      const submitButton = form.querySelector('.submit');
      let checkedProducts = [];

      if (formCheckboxes) {
        [].forEach.call(formCheckboxes, (checkbox) => {
          checkbox.addEventListener('click', () => {
            const checkboxId = checkbox.value;

            if (checkbox.checked) {
              checkedProducts.push(checkboxId);
            } else {
              checkedProducts = checkedProducts.filter(
                (item) => item !== checkboxId,
              );
            }

            if (checkedProducts.length === parseInt(conditions, 10)) {
              submitButton.classList.remove('disabled');
            } else {
              submitButton.classList.add('disabled');
            }
          });
        });
      }

      form.addEventListener('submit', (e) => {
        e.preventDefault();
      });
    });
  }

  const postCartPromo = async (code) => {
    const body = {
      promo: code,
    };

    const response = await postData("/cart/promo", body);

    if (response) {
      if (response.errors) {
        if (promocodeInputWrapper) {
          promocodeInputWrapper.classList.add('error');
        }

        if (promocodeError) {
          promocodeError.classList.add('visible');
          promocodeError.textContent = response.errors._global[0];
        }

        promocodeSubmit.removeAttribute('disabled');
        promocodeSubmit.value = 'Применить';

        applyPromoWithVariants.textContent = 'Далее';
        applyPromoWithVariants.classList.remove('disabled');
      } else {
        if (promocodePopup && promocodePopup.classList.contains('active')) {
          promocodePopup.classList.remove('active');
        }

        promocodeSubmit.removeAttribute('disabled');
        promocodeSubmit.value = 'Применить';

        applyPromoWithVariants.textContent = 'Далее';
        applyPromoWithVariants.classList.remove('disabled');

        if (promocodeSubmit) {
          promocodeSubmit.removeAttribute('disabled');
          promocodeSubmit.value = 'Применить';
        }

        if (promocodeInputWrapper) {
          promocodeInputWrapper.classList.remove('error');
        }

        if (promocodePopupInputWrapper) {
          promocodePopupInputWrapper.classList.remove('full-width');
        }

        if (promocodeError) {
          promocodeError.classList.remove('visible');
          promocodeError.textContent = '';
        }

        if (promocodeForm) {
          promocodeForm.classList.add('hidden');
        }

        if (promoList) {
          promoList.classList.add('static');
        }

        if (
          document.querySelector(`.cancel-promo[data-number="${code}"]`)
        ) {
          document
            .querySelector(`.cancel-promo[data-number="${code}"]`)
            .classList.add('visible');
        }

        if (document.querySelector(`.apply-promo[data-number="${code}"]`)) {
          document
            .querySelector(`.apply-promo[data-number="${code}"]`)
            .classList.add('hidden');
        }

        if (
          document.querySelector(
            `.apply-promo-with-products[data-number="${code}"]`,
          )
        ) {
          document
            .querySelector(
              `.apply-promo-with-products[data-number="${code}"]`,
            )
            .classList.add('hidden');
        }

        if (
          document.querySelector(`.products-wrapper[data-number="${code}"]`)
        ) {
          document
            .querySelector(`.products-wrapper[data-number="${code}"]`)
            .classList.add('hidden');
        }

        if (promotionProductsList) {
          promotionProductsList.innerHTML = '';
        }

        if (
          promocodePopupPromotionProducts &&
          promocodePopupPromotionProducts.classList.contains('visible')
        ) {
          promocodePopupPromotionProducts.classList.remove('visible');
        }

        if (
          promocodeDescription &&
          promocodeDescription.classList.contains('visible')
        ) {
          promocodeDescription.classList.remove('visible');
        }

        if (promocodePopupBackButton) {
          promocodePopupBackButton.classList.remove('hidden');
        }

        if (popupCancelPromoBtn) {
          popupCancelPromoBtn.classList.add('visible');
        }

        promocodeInput.value = '';

        updateCart(response.data, response.data.additional);
        updatedPromosList(response.data.promos, code);
      }
    }
  };

  if (promocodeForm) {
    promocodeForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const { value } = promocodeInput;
      const cookies = document.cookie.split(';');
      let cartId;

      const cartIdCookie = cookies.find((cookie) => cookie.includes('cartId'));

      if (cartIdCookie) {
        cartId = cartIdCookie.split('=');
      }

      if (!cartId) {
        if (promocodeError) {
          promocodeError.classList.add('visible');
          promocodeError.textContent =
            'Невозможно применить промокод, корзина пуста';
        }
      } else {
        promocodeError.classList.remove('visible');
        promocodeError.textContent = '';

        promocodeSubmit.setAttribute('disabled', 'disabled');
        promocodeSubmit.value = 'Загрузка...';

        const response = await fetchData(`/promos/vouchers/${value.trim()}`)

        if (response) {
          if (response.statusCode === 400) {
            if (promocodeForm) {
              const placeholder = promocodeForm.querySelector('.placeholder');

              if (placeholder) {
                placeholder.textContent = 'неверный промокод';
              }

              if (promocodeInputWrapper) {
                promocodeInputWrapper.classList.add('error');
              }
            }

            if (promocodeSubmit) {
              promocodeSubmit.removeAttribute('disabled');
              promocodeSubmit.value = 'Применить';
            }

            return;
          }

          if (response.statusCode === 200) {
            promocodeSubmit.removeAttribute('disabled');
            promocodeSubmit.value = 'Применить';

            if (response.errors) {
              promocodeError.classList.add('visible');
              promocodeError.textContent = response.errors._global[0];
            } else {
              promocodeSubmit.removeAttribute('disabled');
              promocodeSubmit.value = 'Применить';

              applyPromoWithVariants.textContent = 'Далее';
              applyPromoWithVariants.classList.remove('disabled');

              if (promocodeSubmit) {
                promocodeSubmit.removeAttribute('disabled');
                promocodeSubmit.value = 'Применить';
              }

              if (promocodeInputWrapper) {
                promocodeInputWrapper.classList.remove('error');
              }

              if (promocodePopupInputWrapper) {
                promocodePopupInputWrapper.classList.remove('full-width');
              }

              if (promocodeError) {
                promocodeError.classList.remove('visible');
                promocodeError.textContent = '';
              }

              if (promocodeForm) {
                const placeholder = promocodeForm.querySelector(
                  '.placeholder',
                );

                if (placeholder) {
                  placeholder.textContent = 'Введите промокод';
                }

                promocodeForm.classList.add('hidden');
              }

              if (promoList) {
                promoList.classList.add('static');
              }

              if (popupCancelPromoBtn) {
                popupCancelPromoBtn.classList.add('visible');
              }
            }
            updateCart(response.data, response.data.additional);
            updatedPromosList(response.data.promos, value);
          }
        }
      }
    });
  }

  if (applyPromoWithVariants) {
    applyPromoWithVariants.addEventListener('click', async () => {
      const parentElement = applyPromoWithVariants.closest(
        '.promotion-products',
      );
      const number = applyPromoWithVariants.dataset.code;

      if (parentElement) {
        const ids = [];

        const checkedProducts = parentElement.querySelectorAll(
          '.input-button:checked',
        );

        if (checkedProducts) {
          [].forEach.call(checkedProducts, (product) => {
            const productIndex = ids.findIndex(item => item.id === product.value);

            if (productIndex === -1) {
              ids.push({ id: product.value, quantity: 1 });
            } else {
              ids[productIndex].quantity += 1;
            }
          });

          const body = {
            products: JSON.stringify(ids),
            menuType: 'delivery',
          };

          applyPromoWithVariants.textContent = 'Загрузка...';
          applyPromoWithVariants.classList.add('disabled');

          const response = await postData("/cart", body);

          if (response) {
            if (response.statusCode === 200) {
              ids.forEach((id) => {
                const productBuyWrapper = document.querySelector(
                  `.buy-wrapper[data-id="${id}"]`,
                );

                if (productBuyWrapper) {
                  const buyBtn = productBuyWrapper.querySelector(
                    '.buy-button',
                  );
                  const countBtn = productBuyWrapper.querySelector(
                    '.count-button',
                  );

                  if (buyBtn) {
                    buyBtn.classList.add('hidden');
                  }

                  if (countBtn) {
                    const countInput = countBtn.querySelector(
                      '.count-input',
                    );

                    if (countBtn.classList.contains('visible')) {
                      countInput.value = parseInt(countInput.value, 10) + 1;
                    } else {
                      countBtn.classList.add('visible');
                    }
                  }
                }
              });

              updateCart(response.data, response.data.additional);
              postCartPromo(number);
            }
          }
        }
      }
    });
  }

  if (addPromoProductBtn) {
    [].forEach.call(addPromoProductBtn, (btn) => {
      btn.addEventListener('click', async () => {
        const { id } = btn.dataset;

        const body = {
          id,
          quantity: 1,
          menuType: 'delivery',
        };

        btn.textContent = 'Загрузка...';
        btn.classList.add('disabled');

        const response = await postData("/cart", body);

        if (response) {
          if (response.statusCode === 200) {
            const productBuyWrapper = document.querySelector(
              `.buy-wrapper[data-id="${id}"]`,
            );
            const parentElement = btn.closest('.sale-popup-wrapper');

            btn.classList.remove('disabled');
            btn.classList.add('added');
            btn.textContent = 'Добавлено';

            if (parentElement) {
              setTimeout(() => {
                parentElement.classList.remove('active');
                btn.classList.remove('added');
                btn.textContent = 'Добавить в корзину';
              }, 2000);
            }

            if (productBuyWrapper) {
              const buyBtn = productBuyWrapper.querySelector('.buy-button');
              const countBtn = productBuyWrapper.querySelector(
                '.count-button',
              );

              if (buyBtn) {
                buyBtn.classList.add('hidden');
              }

              if (countBtn) {
                const countInput = countBtn.querySelector('.count-input');

                if (countBtn.classList.contains('visible')) {
                  countInput.value = parseInt(countInput.value, 10) + 1;
                } else {
                  countBtn.classList.add('visible');
                }
              }
            }

            updateCart(response.data, response.data.additional);
          } else {
            btn.textContent = 'Добавить в корзину';
          }
        }
      });
    });
  }

  if (applyPromoBtn) {
    [].forEach.call(applyPromoBtn, (btn) => {
      btn.addEventListener('click', () => {
        const { number } = btn.dataset;

        const body = {
          promo: number,
          hidden: true,
        };

        btn.textContent = 'Загрузка...';
        btn.classList.add('disabled');

        applyPromoFromBanner(body, btn);
      });
    });
  }

  if (promoList) {
    promoList.addEventListener('click', (e) => {
      if (e.target.classList.contains('show-popup-btn')) {
        const { id } = e.target.dataset;

        if (document.getElementById(id)) {
          document.getElementById(id).classList.add('active');
        }
      }
    });
  }

  if (popupCancelPromoBtn) {
    popupCancelPromoBtn.addEventListener('click', async () => {
      const { code } = popupCancelPromoBtn.dataset;

      popupCancelPromoBtn.setAttribute('disabled', 'disabled');
      popupCancelPromoBtn.textContent = 'Загрузка...';

      const response = await deleteData(`/cart/promo/${code}`, null);

      if (response) {
        if (response.errors || response.statusCode === 404) {
          popupCancelPromoBtn.removeAttribute('disabled');
          popupCancelPromoBtn.textContent = 'Отменить';
        } else {
          popupCancelPromoBtn.removeAttribute('disabled');
          popupCancelPromoBtn.textContent = 'Отменить';
          popupCancelPromoBtn.dataset.code = '';

          if (promocodePopupInput) {
            promocodePopupInput.value = '';
          }

          if (promocodeDescription) {
            promocodeDescription.classList.remove('visible');
            promocodeDescription.textContent = '';
          }

          if(promocodeInput) {
            promocodeInput.removeAttribute("disabled");
          }

          if (promoError) {
            promoError.textContent = '';
            promoError.classList.remove('green-color');
          }

          if (promocodePopupInputWrapper) {
            promocodePopupInputWrapper.classList.remove('error', 'valid');
          }

          if (promocodePopup) {
            promocodePopup.classList.remove('active');
            document.body.style.overflow = 'auto';
          }

          if (
            document.querySelector(`.cancel-promo[data-number="${code}"]`)
          ) {
            document
              .querySelector(`.cancel-promo[data-number="${code}"]`)
              .classList.remove('visible');
          }

          if (
            document.querySelector(`.apply-promo[data-number="${code}"]`)
          ) {
            document
              .querySelector(`.apply-promo[data-number="${code}"]`)
              .classList.remove('hidden');
          }

          if (
            document.querySelector(
              `.apply-promo-with-products[data-number="${code}"]`,
            )
          ) {
            document
              .querySelector(
                `.apply-promo-with-products[data-number="${code}"]`,
              )
              .classList.remove('hidden');
          }

          if (
            document.querySelector(
              `.products-wrapper[data-number="${code}"]`,
            )
          ) {
            document
              .querySelector(`.products-wrapper[data-number="${code}"]`)
              .classList.remove('hidden');
          }

          if (promotionProductsList) {
            promotionProductsList.innerHTML = '';
          }

          if (promocodeForm) {
            const input = promocodeForm.querySelector('.input');
            const placeholder = promocodeForm.querySelector('.placeholder');
            const inputWrapper = promocodeForm.querySelector(
              '.promocode-input',
            );
            const applyBtn = promocodeForm.querySelector(
              '.promocode-submit',
            );
            const cancelBtn = promocodeForm.querySelector('.remove-promo');

            promocodeForm.classList.remove('hidden');

            if (input) {
              input.value = '';
              input.setAttribute('placeholder', 'Введите промокод');
            }

            if (applyBtn) {
              applyBtn.classList.remove('hidden');
            }

            if (cancelBtn) {
              cancelBtn.classList.remove('visible');
            }

            if (inputWrapper) {
              inputWrapper.classList.remove('valid', 'error', 'focused');
            }

            if (placeholder) {
              placeholder.textContent = 'Введите промокод';
            }
          }

          if (promoList) {
            promoList.classList.remove('static');
          }

          updatedPromosList(response.data.promos);
        }
      }
    });
  }

  if (promoSetButton) {
    [].forEach.call(promoSetButton, (btn) => {
      const { id } = btn.dataset;

      btn.addEventListener('click', () => {
        var parentElement = btn.closest('.sale-popup-wrapper');

        if (parentElement) {
          parentElement.classList.remove('active');
        }

        if (document.getElementById(`set-${id}`)) {
          document.getElementById(`set-${id}`).classList.add('active');
        }
      });
    });
  }
});
